import React from "react";
import { EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";

const ActionButtons = ({ username, customerId, name, mutation, history }) => {
  const [deleteUser] = useMutation(mutation);

  return (
    <>
      <Restricted permissions={[permissions.user_manage]}>
        <EditAction url={`/user/edit/${username}`} />
        <DeleteActionWithModal
          actionButton
          urlOnSuccess="/user/list"
          history={history}
          mutation={deleteUser}
          mutationVariables={{
            customerId: customerId,
            username,
          }}
          elementNameInResult="deleteUser"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  username: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object.isRequired,
};

export default ActionButtons;
